import { render } from "./App.vue?vue&type=template&id=7eae65a3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7eae65a3&lang=css"

import exportComponent from "C:\\Users\\Chikondi Kamwendo\\Projects\\Vue\\care.malawi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__